import { render, staticRenderFns } from "./DashPsychologists.vue?vue&type=template&id=68d69035&scoped=true"
import script from "./DashPsychologists.vue?vue&type=script&lang=js"
export * from "./DashPsychologists.vue?vue&type=script&lang=js"
import style0 from "./DashPsychologists.vue?vue&type=style&index=0&id=68d69035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d69035",
  null
  
)

export default component.exports